(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('BIAProfileEditBreadcrumbController', Controller);

    Controller.$inject = ['$scope', '$state', '$modal', 'biaProfileContainer'];

    function Controller($scope, $state, $modal, biaProfileContainer) {

        $scope.breadcrumbCtrlCtxt = {
            showBCCHelpBtn: false
        };

        $scope.breadcrumbCtrlCtxt.showBCCHelpBtn = _
            .get(biaProfileContainer, 'BIAProfile.IsBusinessContinuityCoordinator', false);

        // Go to BCC Introduction page
        $scope.openBCCIntroduction = function () {
            // Modal to show
            var modalScope = $scope.$new(true);

            modalScope.templatePath = '/app/Main/BCM/biaProfileIntroduction.coordinator.tpl.html';
            modalScope.hideCompleteBtn = true;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/Main/BCM/biaProfileIntroduction.modal.tpl.html',
                placement: 'center'
            });

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        };
    }
})();